<template>
  <div>
    <v-form @submit.prevent="store.salvar()">
      <sds-page
        :title="
          isEditing
            ? 'Edição de Pareceres Referenciais'
            : 'Cadastro de Pareceres Referenciais'
        "
        :navigate-back="true"
        @click:back="$router.go(-1)"
      >
        <CamposDadosBasicos />
        <CamposAlteracaoData
          v-if="isEditing"
          @click:alterar-datas="modalAlterarDatas.show = true"
        />
        <CamposEmenta />

        <v-card-actions class="d-flex justify-end mx-0 px-0">
          <v-btn
            text
            color="primary"
            class="px-5"
            @click="$router.go(-1)"
            data-testid="btn-voltar"
          >
            Voltar
          </v-btn>
          <v-btn
            color="primary"
            depressed
            class="px-5"
            type="submit"
            data-testid="btn-salvar"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </sds-page>

      <sds-confirm
        title="Confirmação"
        message="Deseja realmente excluir o movimento de alteração de datas do parecer?"
        v-model="showModalConfirmacaoExcluirRenovacao"
      >
        <template #actions>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              @click.native="showModalConfirmacaoExcluirRenovacao = false"
            >
              Não
            </v-btn>
            <v-btn color="red" text @click="store.salvar()"> Sim </v-btn>
          </v-card-actions>
        </template>
      </sds-confirm>
    </v-form>
    <ModalAlterarDatas
      v-if="modalAlterarDatas.show"
      @fechar="modalAlterarDatas.show = false"
    />
  </div>
</template>

<script setup lang="ts">
import CamposDadosBasicos from './components/cadastro/CamposDadosBasicos.vue';
import CamposAlteracaoData from './components/cadastro/CamposAlteracaoData.vue';
import CamposEmenta from './components/cadastro/CamposEmenta.vue';
import ModalAlterarDatas from './components/cadastro/ModalAlterarDatas.vue';
import { onMounted, watch } from 'vue';
import { useCadastroParecerReferencialStore } from './store/CadastroParecerReferencialStore';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router/composables';

const store = useCadastroParecerReferencialStore();
const router = useRouter();
const {
  isEditing,
  modalAlterarDatas,
  parecerReferencial,
  showModalConfirmacaoExcluirRenovacao,
} = storeToRefs(store);

onMounted(() => {
  store.$reset();
  store.popularTela();

  const params = new URLSearchParams(window.location.search);

  if (params.has('dadosCpa')) {
    store.parseDadosCPA(params.get('dadosCpa')!);
  } else if (router.currentRoute.params.cdParecerReferencial) {
    parecerReferencial.value.cdParecerReferencial = Number(
      router.currentRoute.params.cdParecerReferencial
    );
    store.buscar();
  }
});

watch(
  () => modalAlterarDatas.value.show,
  (value) => {
    if (value) {
      modalAlterarDatas.value.dtParecer = parecerReferencial.value.dtParecer;
      modalAlterarDatas.value.dtValidade = parecerReferencial.value.dtValidade;
    }
  }
);
</script>
